import { useEffect } from "react";
import { deleteLoginCookieAndSession } from "../utils";

export const useDeleteLoginSession = () => {
  useEffect(() => {
    // const handleBeforeUnload = () => {
    //   console.log("unload");
    //   deleteLoginCookieAndSession();
    // };

    // // Add the event listener
    // window.addEventListener("storage", handleBeforeUnload);

    // // Clean up the event listener on component unmount
    // return () => {
    //   window.removeEventListener("storage", handleBeforeUnload);
    // };

    window.addEventListener("storage", (event: StorageEvent) => {
      if (event.key) {
        // Ensure that the change originated from sessionStorage
        if (sessionStorage.getItem(event.key)) {
          const data = JSON.parse(event.newValue || "{}");
          console.log(`Data updated in other tab: ${data.key} = ${data.value}`);
        }
      }
    });
  }, []);
};
